module.exports = __webpack_public_path__ + "static/img/card_04.8a7b620c.jpg";